(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siy-mobile-menu-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  function update(){
    const source=document.querySelector('template[data-siy011-source]');
    document.querySelectorAll('#menu-drawer [data-siy011-native]').forEach(el=>el.remove());
    document.querySelectorAll('#menu-drawer .siy011-native-original').forEach(el=>el.classList.remove('siy011-native-original'));
    if(!source || source.dataset.enabled!=='true') return;
    document.documentElement.dataset.siy011v2='true';
    document.querySelectorAll('#menu-drawer .siy011-v2-content').forEach(el=>el.remove());
    ['kits','yarns'].forEach(group=>{
      const target=document.querySelector('#link-shop-'+group+' .menu-drawer__inner-submenu');
      const content=source.content.querySelector('[data-siy011-native="'+group+'"]');
      if(!target || !content || !content.querySelector('.siy011-v2-card')) return;
      target.querySelector('ul.menu-drawer__menu')?.classList.add('siy011-native-original');
      target.append(content.cloneNode(true));
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',update,{once:true});else update();
  document.addEventListener('shopify:section:load',update);
  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(update));
  document.addEventListener('shopify:block:select',event=>{
    const card=Array.from(document.querySelectorAll('#menu-drawer [data-siy011-block]')).find(el=>el.dataset.siy011Block===event.detail.blockId || event.detail.blockId.endsWith('__'+el.dataset.siy011Block));
    if(!card || !matchMedia('(max-width:749px)').matches)return;
    const drawer=document.querySelector('#Details-menu-drawer-container');
    if(drawer && !drawer.open) drawer.querySelector('summary')?.click();
    const submenu=card.closest('.menu-drawer__submenu');
    const detail=submenu?.closest('details');
    if(detail && !detail.open)detail.querySelector('summary')?.click();
    card.scrollIntoView({block:'center',behavior:'smooth'});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
